import { IconFont } from '@fast-radius/shared-ui';
import React from 'react';

import { Loading, Money } from 'portal/components';
import { AutoquoteResponseState, isAutoquote, isAutoquoteLoading } from 'portal/lib/autoquote';

interface Props {
  autoquoteResponse: AutoquoteResponseState;
}

const CostRanges = ({ autoquoteResponse }: Props) => {
  return (
    <div className="flex flex-column mt-5">
      <div className="text-md text-coolGray-100 mb-3">
        Cost Estimates
        <IconFont
          name="info-circle"
          className="ml-2 text-lg text-coolGray-300"
          tooltip="All costs shown here are estimates and exclude extra   details like Inspections and Finishes. After you create this quote, we’ll review it to confirm final costs."
        />
      </div>
      <div className="flex flex-row justify-content-between mb-1">
        <div className="text-muted mb-0 font-size-md">Unit price</div>
        {isAutoquoteLoading(autoquoteResponse) ? (
          <Loading height={20} />
        ) : isAutoquote(autoquoteResponse) ? (
          <div className="flex align-items-center font-size-md">
            <Money className="text-coolGray-100" amount={autoquoteResponse.unit_price?.amount} />
          </div>
        ) : (
          <Money amount={null} />
        )}
      </div>
      <div className="flex flex-row justify-content-between text-right">
        <div className="text-coolGray-100 mb-0 font-size-base">Item total</div>
        {isAutoquoteLoading(autoquoteResponse) ? (
          <Loading height={20} />
        ) : isAutoquote(autoquoteResponse) ? (
          <div
            className="flex align-items-center font-size-base"
            data-testid="part-config-item-total"
          >
            <Money
              className="text-coolGray-100 font-semibold"
              amount={autoquoteResponse.total_price?.amount}
            />
          </div>
        ) : (
          <Money amount={null} />
        )}
      </div>
    </div>
  );
};

export default CostRanges;
